import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as authActions from 'redux/modules/auth';
import { translate } from 'react-i18next';

@translate(['common'])
@connect(
  state => ({ reason: state.auth.logoutReason }),
  authActions)
export default
  class LogoutSuccess extends Component {


  render() {
    const { user, logout } = this.props;
    return (
      <div className="container">
        <h3>{this.props.reason}</h3>
      </div>
    )

  }
}
